// 根据环境变量过滤抓网页模块
export const filterTabs = (item: any) => {
  if (import.meta.env.VITE_NO_CRAWLER === 'true' && ['website', 'sitemap', 'gitbook'].includes(item.type)) return false;

  const isLocalMode = import.meta.env.VITE_MODE === 'local';

  if (isLocalMode && ['integration', 'api'].includes(item.type)) return false;

  return true;
};

// 高级数据源类型：仅当该 dataset 历史上有数据时才显示入口。
// 新建 dataset 或无数据的 dataset 永远不显示，避免误用使用率极低的数据源。
const ADVANCED_DATASOURCE_TYPES = ['sitemap', 'gitbook', 'api'] as const;

export const filterAdvancedDatasources = (item: { type: string; counts?: number }) => {
  if (ADVANCED_DATASOURCE_TYPES.includes(item.type as (typeof ADVANCED_DATASOURCE_TYPES)[number])) {
    return (item.counts ?? 0) > 0;
  }
  return true;
};
